module.exports = __webpack_public_path__ + "img/33.3.TP.8663d9e4.png";